export default __webpack_public_path__ + "static/media/sync_data_request_icon.08efb0d7.svg";